import { useContext, useEffect } from 'react';
import TabsContext from '../contexts/TabsContext.js';
import useMemoizedRender from './useMemoizedRender.js';
import useSetup from './useSetup.js';

function useTab(tab) {
  var _useContext = useContext(TabsContext),
    activeTab = _useContext.activeTab,
    register = _useContext.register,
    deregister = _useContext.deregister;
  var isHidden = activeTab !== tab.name;
  var render = useMemoizedRender([isHidden]);
  useSetup(function () {
    return register(tab.name, tab);
  });
  useEffect(function () {
    register(tab.name, tab);
    return function () {
      deregister(tab.name);
    };
  }, [tab.name]);
  return {
    isHidden: isHidden,
    render: render
  };
}

export default useTab;
